import { useCallback, useState } from 'react';

import type { EditorActions } from '@atlaskit/editor-core';

import { getAllSmartLinks } from '../services/links.ts';

export const useInviteFromLinkExperimentEditor = () => {
	const [startingLinks, setStartingLinks] = useState<Set<string>>();

	const onEditorReady = useCallback(async (editorActions: EditorActions) => {
		const adf = await editorActions.getValue();
		const links = getAllSmartLinks(adf);
		setStartingLinks(links);
	}, []);

	return {
		onEditorReady,
		startingLinks,
	};
};
